/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";

const walkingTheTerms = (conceptsToWalk, path, runFunction, above = null, reorganizeConceptsModalState = null) => {
    let conceptWalk = conceptsToWalk;
    for (let index in path) {
        let pathIndex = path[index];
        if (parseInt(index) + 1 === path.length) {  //Meaning it's the last index in the path array
            if (!conceptWalk["concept"]) {
                conceptWalk["concept"] = [];
            }
            runFunction(pathIndex, conceptWalk, reorganizeConceptsModalState, above);
        } else {
            conceptWalk = conceptWalk["concept"][pathIndex];
        }
    }
};

const markTheOldConceptLocation = (pathIndex, conceptWalk, reorganizeConceptsModalState, above) => {
    conceptWalk["concept"][pathIndex]["DELETETHISAFTERMOVE"] = true;
};

const placeConcept = (pathIndex, conceptWalk, reorganizeConceptsModalState, above) => {
    let position = pathIndex + (above ? 0 : 1);
    conceptWalk["concept"] = conceptWalk["concept"].slice(0, position)
        .concat(reorganizeConceptsModalState.movingConcept, conceptWalk["concept"].slice(position));
};

const recursiveWalkToDelete = (conceptWalk) => {
    for (let index in conceptWalk["concept"]) {
        let concept = conceptWalk["concept"][index];
        if (concept["DELETETHISAFTERMOVE"]) {
            conceptWalk["concept"].splice(index, 1);
            break;
        } else if (concept["concept"]) {
            recursiveWalkToDelete(concept);
        }
    }
};

const moveConceptToNewConcept = (moveToConceptPath, setConceptState, reorganizeConceptsModalState, above) => {

    setConceptState(prevState => {
        let newConceptSet = JSON.parse(JSON.stringify(prevState));
        walkingTheTerms(newConceptSet, reorganizeConceptsModalState.movingPath, markTheOldConceptLocation, above, reorganizeConceptsModalState);
        walkingTheTerms(newConceptSet, moveToConceptPath, placeConcept, above, reorganizeConceptsModalState);
        recursiveWalkToDelete(newConceptSet);
        let newConcept = newConceptSet.concept
        return { ...prevState, "concept": newConcept };
    });
};

const MoveConceptButton = ({ moveToConceptPath, setConceptState,
    reorganizeConceptsModalState, setReorganizeConceptsModalState, above }) => {
    return <Button style={{ color: "#000000", padding: "4px" }}
        className="formButton sectionReorganizeButton"
        content="Move Here"
        onClick={() => {
            moveConceptToNewConcept(moveToConceptPath, setConceptState, reorganizeConceptsModalState, above);
            if (!above) {
                if (!(reorganizeConceptsModalState.movingPath.slice(0, reorganizeConceptsModalState.movingPath.length - 1).toString() === moveToConceptPath.slice(0, moveToConceptPath.length - 1).toString() &&
                    reorganizeConceptsModalState.movingPath[reorganizeConceptsModalState.movingPath.length - 1] < moveToConceptPath[moveToConceptPath.length - 1])) {
                    moveToConceptPath = JSON.parse(JSON.stringify(moveToConceptPath));
                    moveToConceptPath[moveToConceptPath.length - 1] += 1;
                }
            }
            setReorganizeConceptsModalState(prevState => {
                return {
                    ...prevState, moveMode: false, movingPath: undefined, newlyMovedPath: moveToConceptPath,
                    newlyMovedLabel: prevState.movingConcept["display"], changesMade: true
                }
            });
        }} />
};

const RecursiveConceptView = ({ json, conceptState, setConceptState,
    reorganizeConceptsModalState,
    setReorganizeConceptsModalState, conceptPath, parentBeingMoved }) => {
    //console.log(json)
    return <div style={{ marginBottom: "12px" }}>
        {json?.concept?.length > 0 &&
            json["concept"].map((concept, index) => {
                let currentConceptPath = conceptPath.concat(index);
                let label = concept.display;
                let beingMoved = reorganizeConceptsModalState.movingPath?.toString() === currentConceptPath.toString();
                let justMoved = reorganizeConceptsModalState.newlyMovedPath?.toString() === currentConceptPath.toString() && reorganizeConceptsModalState.newlyMovedLabel === label;
                let allowDropHere = !beingMoved && reorganizeConceptsModalState.moveMode && currentConceptPath.length > 1 && !parentBeingMoved;

                return <div key={index}>
                    {(index === 0 && allowDropHere) &&
                        <div>
                            <MoveConceptButton moveToConceptPath={currentConceptPath}
                                setConceptState={setConceptState}
                                reorganizeConceptsModalState={reorganizeConceptsModalState}
                                setReorganizeConceptsModalState={setReorganizeConceptsModalState}
                                above={true} />
                        </div>}
                    <div style={{
                        outline: "1px solid #CCCCCC",
                        margin: "4px", padding: "2px",
                        backgroundColor: beingMoved ?
                            "#F8EC8B"
                            :
                            (justMoved && !reorganizeConceptsModalState.moveMode) && "#D5F6D5"
                    }}>
                        {(!reorganizeConceptsModalState.moveMode) &&
                            <>
                                {currentConceptPath.length > 1 &&
                                    <Button positive style={{ color: "#FFFFFF", marginLeft: "6px", padding: "4px" }}
                                        className="formButton sectionReorganizeButton"
                                        content="Move"
                                        onClick={() => {
                                            setReorganizeConceptsModalState(prevState => {
                                                return {
                                                    ...prevState,
                                                    moveMode: true,
                                                    movingPath: currentConceptPath,
                                                    movingConcept: JSON.parse(JSON.stringify(concept))
                                                }
                                            });
                                        }} />
                                }
                            </>
                        }
                        <span><b>{label}</b></span>
                        <>
                            {(reorganizeConceptsModalState.moveMode && beingMoved) &&
                                <> MOVING... <Button negative
                                    style={{ color: "#FFFFFF", marginLeft: "6px", padding: "4px" }}
                                    className="formButton sectionReorganizeButton"
                                    content="Cancel Move"
                                    onClick={() => {
                                        setReorganizeConceptsModalState(prevState => {
                                            return {
                                                ...prevState, moveMode: false, movingPath: undefined
                                            }
                                        });
                                    }} />
                                </>}
                        </>
                        {(concept?.concept?.length > 0)
                            ?
                            <div style={{ marginLeft: "36px" }}>
                                <RecursiveConceptView json={concept} conceptState={conceptState}
                                    setConceptState={setConceptState}
                                    reorganizeConceptsModalState={reorganizeConceptsModalState}
                                    setReorganizeConceptsModalState={setReorganizeConceptsModalState}
                                    conceptPath={currentConceptPath}
                                    parentBeingMoved={parentBeingMoved || beingMoved} />
                            </div>
                            :
                            <>
                                {(reorganizeConceptsModalState.moveMode && !beingMoved && !parentBeingMoved) &&
                                    <div style={{ marginLeft: "36px" }}>
                                        <MoveConceptButton moveToConceptPath={currentConceptPath.concat(0)}
                                            setConceptState={setConceptState}
                                            reorganizeConceptsModalState={reorganizeConceptsModalState}
                                            setReorganizeConceptsModalState={setReorganizeConceptsModalState}
                                            above={true} />
                                    </div>}
                            </>
                        }
                    </div>
                    {allowDropHere && <div>
                        <MoveConceptButton moveToConceptPath={currentConceptPath}
                            setConceptState={setConceptState}
                            reorganizeConceptsModalState={reorganizeConceptsModalState}
                            setReorganizeConceptsModalState={setReorganizeConceptsModalState}
                            above={false} />
                    </div>}
                </div>
            })}
    </div>;
};

const ReorganizeConceptsModal = ({ conceptsReorganizedState, setConceptsReorganizedState,
    reorganizeConceptsModalState, setReorganizeConceptsModalState }) => {

    const [conceptState, setConceptState] = useState({});

    const modalClose = () => {
        setReorganizeConceptsModalState({ modalOpen: false });
    }

    useEffect(() => {
        if (conceptsReorganizedState.concept) {
            setConceptState({
                "concept": [{
                    "display": "The Code System",
                    "concept": conceptsReorganizedState.concept
                }]
            });
        }
    }, []);
    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <div style={{ float: "right" }}>
            {reorganizeConceptsModalState.changesMade ?
                <div>
                    <>
                        <Button className="formButton positive"
                            style={{ padding: "6px 40px", position: "absolute", right: "260px", zIndex: 10 }}
                            content="Apply Changes"
                            onClick={() => {
                                setConceptsReorganizedState({ "reorganized": true, "concept": conceptState.concept[0].concept });
                                modalClose();
                            }}
                        />
                        <Button className="formButton negative"
                            style={{ padding: "6px", position: "absolute", right: "14px", zIndex: 10 }}
                            content="Cancel Changes" title="Close"
                            onClick={() => { modalClose(); }}
                        />
                    </>
                </div>
                :
                <>
                    <Button className="formButton negative"
                        style={{ padding: "6px", position: "absolute", right: "14px", zIndex: 10 }}
                        content="✖" title="Close"
                        onClick={() => {
                            modalClose();
                        }}
                    />
                </>
            }
        </div>
        <br />
        {conceptsReorganizedState["concept"] &&
            <div style={{ margin: "12px 0px" }}>
                <RecursiveConceptView json={conceptState} conceptState={conceptState}
                    setConceptState={setConceptState}
                    reorganizeConceptsModalState={reorganizeConceptsModalState}
                    setReorganizeConceptsModalState={setReorganizeConceptsModalState}
                    conceptPath={[]} />
            </div>}
        <br />
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
};

const ReorganizeConceptsButton = ({ conceptsReorganizedState, setConceptsReorganizedState,
    reorganizeConceptsModalState, setReorganizeConceptsModalState
}) => {

    return <>
        {reorganizeConceptsModalState.modalOpen &&
            <ReorganizeConceptsModal conceptsReorganizedState={conceptsReorganizedState}
                setConceptsReorganizedState={setConceptsReorganizedState}
                reorganizeConceptsModalState={reorganizeConceptsModalState}
                setReorganizeConceptsModalState={setReorganizeConceptsModalState} />}
        <Button style={{ color: "#000000", marginTop: "18px", marginLeft: "6px", fontSize: "18px", padding: "4px" }}
            className="formButton sectionReorganizeButton"
            content="Reorganize Concepts"
            onClick={() => { setReorganizeConceptsModalState(prevState => { return { ...prevState, modalOpen: true } }); }} />
    </>
};

export default ReorganizeConceptsButton;